import useFieldValidation from 'hooks/useFieldValidation';
const VALIDATED_FIELDS = ['name'];
function getFieldLabel(name, t) {
    switch (name) {
        case 'name':
            return t('orderOperators:order_operator_name_capitalize');
        default:
            return name;
    }
}
function getFieldError(name, form, t) {
    var _a;
    return !((_a = form[name]) === null || _a === void 0 ? void 0 : _a.trim()) ? t('specification:required_field') : null;
}
function useOrderOperatorValidation(form, t) {
    return useFieldValidation(VALIDATED_FIELDS, (field) => getFieldError(field, form, t), (field) => getFieldLabel(field, t));
}
export default useOrderOperatorValidation;
